import { entrySteps } from "@/mocks/home";

export default function EntrySection() {
  return (
    <section id="entry" className="border-t border-background-200 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            官网入口
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            四步找到 51视频 官网正确入口
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            网络地址会随时间调整，直接从搜索引擎点进去容易遇到仿冒站或失效页。
            按下面四步操作，可以更快也更安全地进入官方入口。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {entrySteps.map((step) => (
            <div
              key={step.id}
              className="group relative flex flex-col rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50 md:p-6"
            >
              <span className="absolute right-5 top-5 font-heading text-4xl text-background-300 transition-colors group-hover:text-primary-200">
                {String(step.id).padStart(2, "0")}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${step.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="mt-5 inline-flex w-fit rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-900">
                {step.tag}
              </span>
              <h3 className="mt-3 font-heading text-lg text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-3 rounded-xl border border-accent-200 bg-accent-50 p-5 sm:flex-row sm:items-center md:p-6">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
            <i className="ri-lightbulb-flash-line text-xl" aria-hidden="true"></i>
          </span>
          <p className="text-sm leading-relaxed text-foreground-800">
            <strong className="font-medium">小提示：</strong>
            如果记不清官网域名，最稳妥的做法是把本页加入书签。本页收录的地址会持续更新，
            既是官网的入口索引，也是地址失效时的备用目录。
          </p>
        </div>
      </div>
    </section>
  );
}